/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Pre_Checks_TitleInputs */

const en_work_order_publish_pre_checks_title = /** @type {(inputs: Work_Order_Publish_Pre_Checks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Pre-Checks`)
};

const fr_work_order_publish_pre_checks_title = /** @type {(inputs: Work_Order_Publish_Pre_Checks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-vérifications d’export`)
};

const de_work_order_publish_pre_checks_title = /** @type {(inputs: Work_Order_Publish_Pre_Checks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export-Vorabprüfungen`)
};

const it_work_order_publish_pre_checks_title = /** @type {(inputs: Work_Order_Publish_Pre_Checks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlli preliminari all'esportazione`)
};

const ru_work_order_publish_pre_checks_title = /** @type {(inputs: Work_Order_Publish_Pre_Checks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительные проверки при экспорте`)
};

const es_work_order_publish_pre_checks_title = /** @type {(inputs: Work_Order_Publish_Pre_Checks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprobaciones previas a la exportación`)
};

const zh_cn2_work_order_publish_pre_checks_title = /** @type {(inputs: Work_Order_Publish_Pre_Checks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口预检查`)
};

const ja_work_order_publish_pre_checks_title = /** @type {(inputs: Work_Order_Publish_Pre_Checks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートの事前チェック`)
};

const hi_work_order_publish_pre_checks_title = /** @type {(inputs: Work_Order_Publish_Pre_Checks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात पूर्व-जांच`)
};

const pt_pt2_work_order_publish_pre_checks_title = /** @type {(inputs: Work_Order_Publish_Pre_Checks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificações prévias para exportação`)
};

/**
* | output |
* | --- |
* | "Export Pre-Checks" |
*
* @param {Work_Order_Publish_Pre_Checks_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_pre_checks_title = /** @type {((inputs?: Work_Order_Publish_Pre_Checks_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Pre_Checks_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_pre_checks_title(inputs)
	if (locale === "de") return de_work_order_publish_pre_checks_title(inputs)
	if (locale === "it") return it_work_order_publish_pre_checks_title(inputs)
	if (locale === "ru") return ru_work_order_publish_pre_checks_title(inputs)
	if (locale === "es") return es_work_order_publish_pre_checks_title(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_pre_checks_title(inputs)
	if (locale === "ja") return ja_work_order_publish_pre_checks_title(inputs)
	if (locale === "hi") return hi_work_order_publish_pre_checks_title(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_pre_checks_title(inputs)
	return en_work_order_publish_pre_checks_title(inputs)
});